import {PromotionIcons} from '~/common/Icon';
import {PromotionTextTypes} from '~/utils/constants';

interface PromotionButton {
  type: PromotionTextTypes;
  icon: PromotionIcons;
  label: string;
  url: string;
}

export const PromotionButtons: PromotionButton[] = [
  {
    type: PromotionTextTypes.Image,
    icon: PromotionIcons.promoImage,
    label: 'Image Promotions',
    url: '/profile#/create-image-ad',
  },
  {
    type: PromotionTextTypes.Text,
    icon: PromotionIcons.promoText,
    label: 'Text Ads',
    url: '/profile#/create-text-ad',
  },
  /*
  {
    type: PromotionTextTypes.MobileMenu,
    icon: PromotionIcons.promoMenu,
    label: 'Mobile menu Ads',
    url: '/profile/add-mobile-menu',
  },
  {
    type: PromotionTextTypes.Url,
    icon: PromotionIcons.promoUrl,
    label: 'URL Promotions',
    url: '/profile/add-promote-url',
  },
  */
  {
    type: PromotionTextTypes.TopSpot,
    icon: PromotionIcons.promoTopspot,
    label: 'Top Spot Images',
    url: '/profile/add-promote-top-spot',
  },
];
